/**
 * Created by chad on 3/15/17.
 */


export default class PersonalOffer {
    constructor(PersonalOfferObject) {
        this._congratulations = PersonalOfferObject.congratulations;
        this._countryCode = PersonalOfferObject.countryCode;
        this._date = PersonalOfferObject.date;
        this._discount = PersonalOfferObject.discount;
        this._event = PersonalOfferObject.event;
        this._greeting = PersonalOfferObject.greeting;
        this._isGroupOffer = PersonalOfferObject.isGroupOffer;
        this._items = PersonalOfferObject.items;
        this._name = PersonalOfferObject.name;
        this._owner = PersonalOfferObject.owner;
        this._sapId = PersonalOfferObject.sapId;
        this._sponsor = PersonalOfferObject.sponsor;
        this._pitchID = PersonalOfferObject.pitchID;
        this._landingPageURL = PersonalOfferObject.landingPageURL;
    }

    toJSON() {
        return {
            congratulations: this._congratulations,
            countryCode: this._countryCode,
            date: this._date,
            discount: this._discount,
            event: this._event,
            greeting: this._greeting,
            isGroupOffer: this._isGroupOffer,
            items: this._items,
            name: this._name,
            owner: this._owner,
            sapId: this._sapId,
            sponsor: this._sponsor,
            pitchID: this._pitchID,
            landingPageURL: this._landingPageURL
        };
    }

    get congratulations() {
        return this._congratulations;
    }
    set congratulations(value) {
        this._congratulations = value;
    }

    get countryCode() {
        return this._countryCode;
    }

    set countryCode(value) {
        this._countryCode = value;
    }

    get date() {
        return this._date;
    }

    set date(value) {
        this._date = value;
    }

    get discount() {
        return this._discount;
    }

    set discount(value) {
        this._discount = value;
    }

    get event() {
        return this._event;
    }

    set event(value) {
        this._event = value;
    }

    get greeting() {
        return this._greeting;
    }

    set greeting(value) {
        this._greeting = value;
    }

    get isGroupOffer() {
        return this._isGroupOffer;
    }

    set isGroupOffer(value) {
        this._isGroupOffer = value;
    }

    get items() {
        return this._items;
    }

    set items(value) {
        this._items = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get owner() {
        return this._owner;
    }

    set owner(value) {
        this._owner = value;
    }

    get sapId() {
        return this._sapId;
    }

    set sapId(value) {
        this._sapId = value;
    }

    get sponsor() {
        return this._sponsor;
    }

    set sponsor(value) {
        this._sponsor = value;
    }

    get pitchID() {
        return this._pitchID;
    }

    set pitchID(value) {
        this._pitchID = value;
    }

    get landingPageURL() {
        return this._landingPageURL;
    }

    set landingPageURL(value) {
        this._landingPageURL = value;
    }
}
